import Analytics from "../../dom/utils/Analytics";

const externalPage = <HTMLElement>document?.querySelector("#external-site");
const ui = <HTMLElement>document?.querySelector(".ui");

const backButton = document?.querySelector("#external-site-back-button");
const confirmButton = document?.querySelector(".external-site-confirm-button");

const downloadPage = <HTMLElement>document?.querySelector(".download");
export let currentPage = "homepage";

const ExternalLink = () => {
  if (!confirmButton) return;

  confirmButton.addEventListener("click", () => {
    const currentLink = confirmButton.getAttribute("data-href");
    if (currentLink) {
      window.open(currentLink, "_blank");
    }
    confirmButton?.classList.add("active");

    externalPage.style.display = "none";
    ui.style.display = "flex";

    Analytics.pushEvent({
      event: "page_view",
      parameter: "external_link_confirm",
      parameterValue: ""
    })
  });

  backButton?.addEventListener("click", () => {
    externalPage.style.display = "none";
    ui.style.display = "flex";

    Analytics.pushEvent({
      event: "page_view",
      parameter: "external_link_back",
      parameterValue: ""
    })

  });
};

export default ExternalLink;
